<ng-container *ngIf="groupInfoCardParameters">
  <div fxLayout="row wrap">
    <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
      <ct-card [parameters]="groupInfoCardParameters"></ct-card>
    </div>
  </div>
</ng-container>

<!-- Card Nuova Spedizione e Business Intelligence -->
<div fxLayout="row wrap">
  <!-- Card Nuova Spedizione: 50% se BiEnabled, altrimenti 100% -->
  <div [fxFlex.gt-sm]="biEnabled ? '50' : '100'" fxFlex.gt-xs="100" fxFlex="100">
    <ct-card [parameters]="sendLettersCardParameters"></ct-card>
  </div>
  
  <!-- Card Business Intelligence: mostrata solo se BiEnabled è true -->
  <div *ngIf="biEnabled && biReportCardParameters" fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <ct-card [parameters]="biReportCardParameters"></ct-card>
  </div>
</div>

<div fxLayout="row wrap">
  <div fxFlex.gt-sm="33.33" fxFlex.gt-xs="100" fxFlex="100" *ngFor="let widget of widgets">
    <ct-widget [configuration]="widget"></ct-widget>
  </div>
</div>


<ng-container *ngIf="administrativeWidgets.length > 0">

  <mat-divider></mat-divider>

  <div fxLayout="row wrap">
    <div
      fxFlex.gt-sm="33.33"
      fxFlex.gt-xs="100"
      fxFlex="100"
      *ngFor="let widget of administrativeWidgets"
    >
      <ct-widget [configuration]="widget"></ct-widget>
    </div>
  </div>


</ng-container>
